import { productCarouselProductStyles as styles } from "@solveindustrial/Overrides/Components/ProductCarouselProduct";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.productImageStyles = {
    ...styles.productImageStyles,
    linkWrappingImage: {
        ...styles.productImageStyles?.linkWrappingImage,
        css: css`
            ${styles.productImageStyles?.linkWrappingImage?.css}
            margin: 0;
        `,
    },

    img: {
        ...styles.productImageStyles?.img,
        css: css`
            width: 100%;
            height: 250px;
            object-fit: contain;
        `,
    },
};

styles.qtyGridItem = {
    ...styles.qtyGridItem,
    width: [4, 6, 4, 4, 4],
};

styles.addToCartButtonGridItem = {
    ...styles.addToCartButtonGridItem,
    width: [8, 12, 8, 8, 8],
};

styles.productAddToCartButtonStyles = {
    ...styles.productAddToCartButtonStyles,

    css: css`
        ${styles.productAddToCartButtonStyles?.css}

        ${mediaQueriesBP.maxMD} {
            height: 30px;
            min-height: 30px;
        }
    `,
};

styles.productBrandStyles = {
    logoImage: {
        ...styles.productBrandStyles?.logoImage,
        css: css`
            ${styles.productBrandStyles?.logoImage?.css}
            max-height: 50px;

            img {
                width: 100%;
                height: auto;
                object-fit: contain;
            }
        `,
    },
};

styles.qtyGridItem = {
    ...styles.qtyGridItem,
    css: css`
        ${styles.qtyGridItem?.css}

        display: flex;
        flex-direction: column;
        gap: 5px;
    `,
};

styles.addToCartContainer = {
    ...styles.addToCartContainer,
    offsetCss: css`
        ${styles.addToCartContainer?.offsetCss}
        align-items: flex-end;
    `,
};

styles.productAddToListLinkStyles = {
    ...styles.productAddToListLinkStyles,
    link: {
        typographyProps: {
            css: css`
                font-size: 14px;
                line-height: 25px;

                ${mediaQueriesBP.minMD} {
                    font-size: 16px;
                    line-height: 29px;
                }
            `,
        },
    },
};

styles.productBrandWrapper = {
    ...styles.productBrandWrapper,
    css: css`
        ${styles.productBrandWrapper?.css}
        margin: 0;
    `,
};

styles.productDescriptionStyles = {
    ...styles.productDescriptionStyles,
    productDetailLink: {
        ...styles.productDescriptionStyles?.productDetailLink,
        css: css`
            ${styles.productDescriptionStyles?.productDetailLink?.css}
            margin: 0;
        `,
    },
};

styles.productPartNumbersStyles = {
    container: {
        ...styles.productPartNumbersStyles?.container,
        gap: 0,
        css: css`
            ${styles.productPartNumbersStyles?.container?.css}
            margin-bottom: 0;
        `,
        offsetCss: css`
            ${styles.productPartNumbersStyles?.container?.offsetCss}
            display: flex;
            flex-direction: column;
            gap: 10px;
        `,
    },
};

styles.logInForPriceButtonStyles = {
    guestButtonStyles: {
        ...styles.logInForPriceButtonStyles?.guestButtonStyles,
        css: css`
            ${styles.logInForPriceButtonStyles?.guestButtonStyles?.css}
            width: max-content;
            margin: auto 0 0;
        `,
    },
};
